import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Text,
  Tooltip,
  useDisclosure,
} from '@chakra-ui/react'
import React from 'react'
import { api } from '../../../../services/api'
import { user } from '../../../../helpers/user'

export function ConfirmDialog({ item, resultado }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const cancelRef = React.useRef()
  const [loading, setLoading] = React.useState(false)

  const bloquearEmissao = !item.nf_liberada

  async function updateUsu() {
    setLoading(true)
    const params = {
      numero_unico: item.numero_unico,
      codigo_produto: item.codigo_produto,
      numero_pedido: item.numero_pedido,
      nunota_org: item.nunota_org,
      nome_usuario: user?.nome_usuario,
    }

    const response = await api.post('/site/v2/pedido/atualiza-pendencia-nota', params)

    console.log('response: ', response)

    onClose()
    resultado({ codParc: '', pedido: '', dataDe: '', dataAte: '', pendente: '', nfe: '' })
    setLoading(false)
  }

  return (
    <>
      <Button disabled={bloquearEmissao} onClick={onOpen} colorScheme={bloquearEmissao ? 'red' : 'blue'} size="sm">
        {bloquearEmissao ? (
          <Tooltip label={item.motivo_bloqueio} fontSize="md">
            <Text as="span" fontSize="sm">
              Emissão Bloqueada
            </Text>
          </Tooltip>
        ) : (
          'Confirmar'
        )}
      </Button>
      <AlertDialog motionPreset="slideInBottom" leastDestructiveRef={cancelRef} onClose={onClose} isOpen={isOpen} isCentered>
        <AlertDialogOverlay />

        <AlertDialogContent>
          <AlertDialogHeader>Tem certeza?</AlertDialogHeader>
          <AlertDialogCloseButton />
          <AlertDialogBody>
            Você está prestes a confirmar o pedido <strong>{item.numero_pedido}</strong>
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button onClick={() => updateUsu()} colorScheme="blue" isLoading={loading} loadingText="Enviando">
              Sim
            </Button>
            <Button colorScheme="red" ref={cancelRef} onClick={onClose} ml={3}>
              Não
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  )
}
